interface WidgetLoadingProps {
  label?: string;
  /** Neutral arc instead of the brand one, for the boot state where the brand isn't known yet. */
  neutral?: boolean;
}

/** Spinner + optional label, so "loading" always looks designed. */
export function WidgetLoading({ label, neutral = false }: WidgetLoadingProps) {
  return (
    <div className="sm-boot">
      <div
        className={['sm-stack sm-loading', neutral ? 'sm-loading-neutral' : null]
          .filter(Boolean)
          .join(' ')}
      >
        <span className="sm-spinner" aria-hidden="true" />
        {label !== undefined ? <p className="sm-type-body sm-muted">{label}</p> : null}
      </div>
    </div>
  );
}
